@if (product$ | async; as product) { @if (gstInclusive !== null && gstExclusive !== null && tooltipIconConfig !== null)
{
<div class="pdp-price" [ngClass]="[activeLanguage$ | async, activeCountry$ | async]" [class.srp-toggle-on]="showSrp">
  <div class="srp-price">
    <div class="price-label-info">
      <span class="pdp-price-label" [ngClass]="activeLanguage$ | async">{{
        'product.productList.srp' | cxTranslate
      }}</span>
      @if (tooltipIconConfig?.enabled) {
      <app-tooltip-icon
        [matIconName]="tooltipIconConfig?.matIconName"
        [matIconTheme]="tooltipIconConfig?.matIconTheme"
        [placement]="float ? 'bottom-right' : 'top-right'"
        [size]="tooltipIconConfig?.size"
        [tooltipContent]="'tooltip.srp' | cxTranslate"
        [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
      ></app-tooltip-icon>
      }
    </div>
    <span class="pdp-price-value">{{ product?.srpPrice?.formattedValue }}</span>
    @if (product?.srpPrice?.formattedValue && gstInclusive) {
    <span class="gst-label">{{ 'gst.inclusive' | cxTranslate }}</span>
    }
  </div>
  @if (!showSrp && !basepriceHidden) {
  <div class="base-price">
    <div class="price-label-info">
      <span class="pdp-price-label">{{ 'product.productList.basePrice' | cxTranslate }}</span>
      @if (tooltipIconConfig?.enabled) {
      <app-tooltip-icon
        [matIconName]="tooltipIconConfig?.matIconName"
        [matIconTheme]="tooltipIconConfig?.matIconTheme"
        [placement]="float ? 'bottom-right' : 'top-right'"
        [size]="tooltipIconConfig?.size"
        [tooltipContent]="'tooltip.basePrice' | cxTranslate"
        [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
      ></app-tooltip-icon>
      }
    </div>
    <span class="pdp-price-value">{{ product?.basePrice?.formattedValue }}</span>
    @if (product?.basePrice?.formattedValue && gstExclusive) {
    <span class="gst-label">{{ 'gst.exclusive' | cxTranslate }}</span>
    }
  </div>
  } @if (!showSrp) {
  <div class="dealer-price">
    <div class="price-label-info">
      <span class="pdp-price-label">{{ 'product.productList.dealerPrice' | cxTranslate }}</span>
      @if (tooltipIconConfig?.enabled) {
      <app-tooltip-icon
        [matIconName]="tooltipIconConfig?.matIconName"
        [matIconTheme]="tooltipIconConfig?.matIconTheme"
        [placement]="float ? 'bottom-right' : 'top-right'"
        [size]="tooltipIconConfig?.size"
        [tooltipContent]="
          (dealerPrice(product.code) ? 'tooltip.hasDealerPrice' : 'tooltip.hasNoDealerPrice') | cxTranslate
        "
        [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
      ></app-tooltip-icon>
      }
    </div>
    @if (!dealerPrice(product.code)) {
    <div class="spinner-shimano-wrapper-dp">
      @if (this.hasDealerPrice) {
      <div class="spinner-shimano">
        {{ setDisabled() }}
        <div></div>
      </div>
      } @if (!this.hasDealerPrice) {
      <div class="no-dealer-price no-dealer-price-pdp"></div>
      }
    </div>
    } @else {
    {{ setEnabled() }}
    @if (erpPromotions$ | async; as erpproduct) { @if ( erpproduct.dealerPrices.length > 0 &&
    erpproduct.dealerPrices[0].promotionMessage && erpproduct.dealerPrices[0].promotionMessage !== '') {
    <span class="pdp-price-value erp-promo">{{ dealerPrice(product.code) }}</span>
    @if (dealerPrice(product.code) && gstExclusive) {
    <span class="gst-label">{{ 'gst.exclusive' | cxTranslate }}</span>
    }
    <span>{{ erpproduct.dealerPrices[0].promotionMessage }}</span>
    } @else {
    <span class="pdp-price-value">{{ dealerPrice(product.code) }}</span>
    @if (dealerPrice(product.code) && gstExclusive) {
    <span class="gst-label">{{ 'gst.exclusive' | cxTranslate }}</span>
    } } } @else {
    <span class="pdp-price-value">{{ dealerPrice(product.code) }}</span>
    @if (dealerPrice(product.code) && gstExclusive) {
    <span class="gst-label">{{ 'gst.exclusive' | cxTranslate }}</span>
    } } }
  </div>
  }
</div>
} }
